import { DataDictionary as DataDictionaryType } from "@aidkitorg/types/lib/survey";
import { ArrowDownOnSquareIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { usePost } from "../API";
import { downloadDataDictionary } from "../AdminPanel/Dashboards/utils/downloadDataDictionary";
import { BUTTON_CLASS, SpacedSpinner } from "../Util";
import { useToast } from "@aidkitorg/component-library";

export function DataDictionary(props: { component: DataDictionaryType }) {
  const getDataDictionary = usePost('/survey/get_data_dictionary');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { toast } = useToast();

  const handleDataDictionaryDownload = async () => {
    setIsLoading(true);
    try {
      await downloadDataDictionary({
        fileType: props.component.type || 'csv',
        getDataDictionary: () => getDataDictionary({
          limitToSubsurvey: props.component.limitToSubsurvey,
          excludeFields: props.component.excludeFields,
          includeComputations: props.component.includeComputations,
          excludeKinds: props.component.excludeKinds,
        }),
        onUnsupportedType: (type) => toast({
          description: 'Unrecognized DataDictionary type: ' + type,
          variant: 'error',
        }),
      });
    } finally {
      setIsLoading(false);
    }
  }

  return <div className="my-2">
    <button className={BUTTON_CLASS}
      onClick={handleDataDictionaryDownload}>
      Get Data Dictionary {props.component.limitToSubsurvey} ( {props.component.type} )
      <span className="ml-2">
        <ArrowDownOnSquareIcon width="20" height="20" className="inline" />
      </span>
    </button>
    {isLoading && <SpacedSpinner />}
  </div>
}
